import type { ComponentRef } from '@wix/public-editor-platform-interfaces';
import { AllowedEvents, AppEventPayload, PrivateAPIFixMe } from './types';
import { IElement } from '@wix/public-editor-platform-interfaces';

// TODO: remove events shape and remove payload transformations
export async function transformEventPayload<T extends AllowedEvents>(
  eventPayload: Record<string, string>,
  privateAPI: PrivateAPIFixMe,
): Promise<AppEventPayload<T>> {
  if (!eventPayload?.type) {
    return eventPayload as AppEventPayload<T>;
  }

  switch (eventPayload.type) {
    case 'componentSelectionChanged':
      const componentRefs = (eventPayload.componentRefs ||
        []) as unknown as ComponentRef[];

      const components = (await Promise.all(
        componentRefs.map((ref) => {
          return privateAPI.components.getComponent(ref);
        }),
      )) as IElement[];

      return {
        type: eventPayload.type,
        components,
      } as AppEventPayload<T>;

    default:
      return eventPayload as AppEventPayload<T>;
  }
}
